import { toast } from 'react-toastify';

export const showSuccessToast = (message: string) => {
  toast(message, { type: 'success', position: 'top-center', hideProgressBar: true });
};

export const showErrorToast = (message: string) => {
  toast(message, { type: 'error', position: 'top-center', hideProgressBar: true });
};
